<template>
    <br>
    <div id="service-multiple" class="one-service-area ptb-100">
        <div class="container">
            <div class="one-section-title">
                <span class="sub-title">{{ subTitle }}</span>
                <h2>{{ heading }}</h2>
            </div>

            <!-- Tabs centradas -->
            <nav class="tabs">
                <div class="tabs__header">
                    <a class="tabs__header-item" v-for="tab in tabs" v-on:click="selectTab(tab.id)"
                        v-bind:class="{ 'active': activeTab == tab.id }" :key="tab.id">
                        <div class="service-item">
                            <i :class="tab.icon"></i>
                            <span>{{ tab.name }}</span>
                        </div>
                    </a>
                </div>
            </nav>

            <!-- Contenedor de contenido centrado -->
            <div class="tabs__container tabs__container--center">
                <div class="tabs__list" ref="tabsList">
                    <div class="tabs__list-tab" v-for="tab in tabs" v-bind:class="{ 'active': activeTab == tab.id }"
                        :key="tab.id">
                        <div class="service-advisor">
                            <div class="row align-items-center">
                                <div class="col-lg-6">
                                    <div class="advisor-img">
                                        <img :src="tab.image" alt="Tintas">
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="advisor-content">
                                        <h2>{{ tab.title }}</h2>
                                        <p>{{ tab.shortDesc }}</p>
                                        <ul>
                                            <li v-for="list in tab.lists" :key="list.id">
                                                <i :class="list.icon"></i>
                                                {{ list.text }}
                                            </li>
                                        </ul>
                                        <div class="advisor-link">
                                            <a href="tel:+34 623 61 51 28">
                                                COMPRAR / PEDIR
                                            </a>
                                            <i class="bx bx-right-arrow-alt"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OurCoreService',
    props: ['subTitle', 'heading'],
    data() {
        return {
            activeTab: 1,
            offsetRight: 0,

            tabs: [
                // 1. Servicio técnico y mantenimiento
                {
                    id: 1,
                    icon: 'bx bx-wrench',
                    name: 'Servicio técnico',
                    title: 'Condiciones del servicio técnico y mantenimiento',
                    shortDesc:
                        'Realizamos instalación, diagnóstico, reparación y mantenimiento preventivo/correctivo de equipos de impresión digital para garantizar la continuidad de tu producción.',
                    image: require('@/assets/img/resources/p2.png'),
                    lists: [
                        {
                            id: 1,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Atendemos averías, atascos, fallos de calidad de impresión y problemas de calibración.'
                        },
                        {
                            id: 2,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Ofrecemos mantenimiento preventivo para alargar la vida útil del equipo y evitar paradas inesperadas.'
                        },
                        {
                            id: 3,
                            icon: 'bx bxs-chevrons-right',
                            text: 'El mantenimiento correctivo se centra en reparar fallas ya detectadas para volver a producir cuanto antes.'
                        },
                        {
                            id: 4,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Para asistencias presenciales fuera de Málaga se aplican costes de desplazamiento (Dependiendo de la ubicación).'
                        }, 
                        {
                            id: 5,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Garantía 30 días sobre la intervención realizada (no cubre fallos ajenos, mal uso o piezas diferentes).'
                        },
                    ]
                },

                // 2. Repuestos y consumibles
                {
                    id: 2,
                    icon: 'bx bx-droplet',
                    name: 'Tintas y recambios',
                    title: 'Venta de tintas para impresión digital',
                    shortDesc:
                        'En Plotix ofrecemos tintas originales y compatibles para plotters y equipos de impresión digital. Nos aseguramos de que cada cliente reciba la mejor opción según su máquina, tipo de cabezal y uso profesional.',
                    image: require('@/assets/img/resources/p1.png'),
                    lists: [
                        {
                            id: 1,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Disponemos de tintas originales de alta calidad para garantizar el máximo rendimiento y fidelidad del color.'
                        },
                        {
                            id: 2,
                            icon: 'bx bxs-chevrons-right',
                            text: 'También ofrecemos tintas compatibles de excelente desempeño, seleccionadas y testadas por nuestro servicio técnico.'
                        },
                        {
                            id: 3,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Asesoramos a cada cliente sobre la tinta más adecuada para su modelo de impresora y necesidades de producción.'
                        },
                        {
                            id: 4,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Todas nuestras tintas cumplen estándares de calidad, estabilidad y durabilidad, evitando daños en el sistema de impresión.'
                        }
                    ]
                },
                // 6. Cobertura y tiempos de respuesta (NUEVA SECCIÓN)

                {
                    id: 3,
                    icon: 'bx bx-map-pin',
                    name: 'Cobertura y movilidad',
                    title: 'Cobertura técnica y desplazamientos de servicio',
                    shortDesc:
                        'Nuestro equipo técnico se desplaza hasta tu ubicación para ofrecerte asistencia profesional en tus instalaciones. Garantizamos cobertura directa en Málaga y zonas cercanas, asegurando tiempos de respuesta rápidos y sin coste adicional en la región.',
                    image: require('@/assets/img/resources/p3.png'),
                    lists: [
                        {
                            id: 1,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Ofrecemos desplazamiento gratuito dentro del área de Málaga capital, Fuengirola y Marbella.'
                        },
                        {
                            id: 2,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Para zonas fuera de este radio se aplicará un pequeño plus por transporte y kilometraje.'
                        },
                        {
                            id: 3,
                            icon: 'bx bxs-chevrons-right',
                            text: 'El tiempo de respuesta dependerá de la carga de trabajo y la distancia, pero priorizamos siempre las averías urgentes en producción.'
                        },
                        {
                            id: 4,
                            icon: 'bx bxs-chevrons-right',
                            text: 'También brindamos diagnóstico y soporte remoto para resolver incidencias menores sin necesidad de desplazamiento.'
                        }
                    ]
                },
            ]
        }
    },
    methods: {
        selectTab(id) {
            const tabsList = this.$refs.tabsList
            this.activeTab = id
            this.offsetRight = tabsList.clientWidth * (id - 1)
            tabsList.style.right = this.offsetRight + 'px'
        }
    },
    mounted() {
        const tabsList = this.$refs.tabsList
        tabsList.style.right = this.offsetRight + 'px'
    },
    computed: {
        products() {
            return this.$store.state.products.all.filter(item => {
                return item.productsType === 'left-sidebar'
            })
        }
    }
}
</script>

<style scoped>
/* ===============================
   Bloque de pestañas centradas
   =============================== */

/* Contenedor de tabs centrado y con columnas iguales */
.tabs__header {
    display: grid;
    grid-template-columns: repeat(2, minmax(200px, 280px));
    /* botones iguales */
    gap: 1rem;
    justify-content: center;
    /* 🔹 centra el grupo de botones */
    align-items: center;
    margin: 0 auto 2rem;
    /* centrado + espacio inferior */
    width: 100%;
}

/* Cada enlace ocupa toda su celda */
.tabs__header-item {
    display: block;
    text-decoration: none;
    width: 100%;
}

/* Botón */
.service-item {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 16px 18px;
    border-radius: 10px;
    transition: all 0.3s ease;
}

/* Estado activo */
.tabs__header-item.active .service-item {
    background: var(--main-color, #d35400);
    color: #fff;
}

/* Estado inactivo */
.tabs__header-item:not(.active) .service-item {
    background: #f4f4f4;
    color: #333;
}

/* Hover */
.tabs__header-item:hover .service-item {
    opacity: 0.9;
}

/* Responsive: en móviles apila verticalmente */
@media (max-width: 600px) {
    .tabs__header {
        grid-template-columns: 1fr;
        max-width: 360px;
        justify-content: center;
    }
}

/* ===============================
   Contenido del bloque general
   =============================== */

.tabs__container--center {
    max-width: 1100px;
    margin: 0 auto;
}

.one-section-title {
    text-align: center;
}

.one-section-title h2 {
    margin-bottom: 2rem;
}

/* Estilo del enlace dentro de cada pestaña */
.advisor-link a {
    color: var(--main-color, #d35400);
    font-weight: bold;
    text-decoration: none;
}

/* ====== Fix centrado y ancho ESTABLE SOLO en tablet (768–1199px) ====== */
@media (min-width: 768px) and (max-width: 1199px) {

    /* Centra el contenedor de tabs dentro del .container */
    .tabs {
        display: flex;
        justify-content: center;
    }

    /* 2 columnas fijas y centradas, sin permitir encogimiento */
    .tabs__header {
        display: grid;
        grid-template-columns: repeat(2, 280px);
        /* ancho fijo por botón */
        gap: 1rem;
        justify-content: center;
        /* centra el grupo */
        margin-left: auto;
        margin-right: auto;
        max-width: calc(560px + 1rem);
        /* 2×280 + gap */
    }

    /* Evita que el contenido se “aplane” en puntos intermedios */
    .tabs__header-item,
    .tabs__header-item .service-item {
        min-width: 280px;
        /* coincide con la columna */
        flex: 0 0 auto;
        /* no encoge en ningún caso */
    }
}
</style>
